'use strict';

import summernoteConfig from '../summernote.config';

export default class EditController {

  /*@ngInject*/
  constructor($http, $stateParams, $state, toaster, Upload) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.toaster = toaster;
    this.Upload = Upload;
    this.summernoteConfig = summernoteConfig;
    this.availableCountArr = [
      {
        value: 0,
        name: '不限'
      },
      {
        value: 10,
        name: '10'
      },
      {
        value: 20,
        name: '20'
      },
      {
        value: 50,
        name: '50'
      },
      {
        value: 100,
        name: '100'
      },
      {
        value: 200,
        name: '200'
      },
      {
        value: 300,
        name: '300'
      },
      {
        value: 400,
        name: '400'
      },
      {
        value: 500,
        name: '500'
      },
      {
        value: 600,
        name: '600'
      },
      {
        value: 700,
        name: '700'
      },
      {
        value: 800,
        name: '800'
      },
      {
        value: 900,
        name: '900'
      },
      {
        value: 1000,
        name: '1000'
      },
      {
        value: 2000,
        name: '2000'
      },
      {
        value: 3000,
        name: '3000'
      },
      {
        value: 4000,
        name: '4000'
      },
      {
        value: 5000,
        name: '5000'
      },
      {
        value: 6000,
        name: '6000'
      }
    ]
  }

  $onInit() {
    this.getFirmware();
    this.getBetaGroups();
  }

  getFirmware() {
    this.$http.get(`/api/firmware/${this.$stateParams.id}`).then(res => {
      this.firmware = res.data;
      if (this.isChangeListHtmlUrl(this.firmware.changeListHtml) && !this.firmware.changeListHtmlUrl) {
        this.firmware.changeListHtmlUrl = this.firmware.changeListHtml;
        this.firmware.changeListHtml = '';
      }
      if (!this.firmware.changeListHtml && !this.firmware.changeListHtmlUrl && this.firmware.changeList && this.firmware.changeList.length) {
        this.firmware.changeListHtml = this.firmware.changeList.join('<br>');
      }
    })
  }

  save() {
    if (this.firmware.changeListHtml && !this.isChangeListHtmlUrl(this.firmware.changeListHtml)) {
      let text = this.firmware.changeListHtml.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n').replace(/<[^>]+>/g, '');
      this.firmware.changeList = text.split('\n').filter(line => line.trim().length > 0);
    }
    if (!this.checkData()) {
      return;
    }
    if (this.firmware.buildDisplayId) {
      this.firmware.buildDisplayId = this.firmware.buildDisplayId.trim();
    }
    this.$http.put(`/api/firmware/${this.$stateParams.id}`, this.firmware).then(res => {
      this.$state.go('^');
    })
  }

  getBetaGroups() {
    this.$http.get('/api/betaGroups').then(res => {
      this.betaGroups = res.data;
    });
  }

  uploadChangeListHtml(file) {
    if (!file) {
      return;
    }
    this.toaster.pop({
      type: 'wait',
      title: '正在上传HTML，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: '/api/firmware/uploadChangeListHtml',
      file: file,
      data: {
        downloadUrlList: this.firmware.downloadUrlList
      },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.firmware.changeListHtml = '';
      this.firmware.changeListHtmlUrl = data.url;
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

  deleteChangeListHtml() {
    if (!this.firmware.changeListHtmlUrl) {
      return;
    }
    this.toaster.pop({
      type: 'wait',
      title: '正在删除HTML，请稍等...',
      timeout: 3000 * 1000
    });
    this.$http.delete(`/api/firmware/${this.$stateParams.id}/changeListHtml`).then(res => {
      this.toaster.clear();
      this.firmware = res.data;
      this.changeListHtmlFile = null;
      this.toaster.pop('success', '删除成功');
    }).catch(err => {
      this.toaster.clear();
      this.toaster.pop('error', '删除失败', JSON.stringify(err.data || err));
    });
  }

  toggleSelection(id) {
    let idx = this.firmware.betaGroups.indexOf(id);

    if (idx > -1) {
      this.firmware.betaGroups.splice(idx, 1);
    } else {
      this.firmware.betaGroups.push(id);
    }
  }

  checkStr(str) {
    if (str && typeof str == 'string') {
      str = str.trim();
    }
    return str;
  }

  checkArr(arr) {
    let res = false;
    if (!arr || !arr.forEach) {
      return res;
    }
    arr.forEach(item => {
      if (item.trim().length > 0) {
        res = true;
      }
    });
    return res;
  }

  isChangeListHtmlUrl(html) {
    return typeof html === 'string' && /^https?:\/\//i.test(html);
  }

  checkData() {
    if (this.checkStr(this.firmware.model) && this.checkStr(this.firmware.brand)
      && this.firmware.buildNumber && this.checkStr(this.firmware.buildType) && this.checkStr(this.firmware.fingerprint)
      && this.checkStr(this.firmware.lang) && this.checkStr(this.firmware.md5)
      && this.firmware.size && (this.checkArr(this.firmware.changeList) || this.checkStr(this.firmware.changeListHtml) || this.checkStr(this.firmware.changeListHtmlUrl))) {
      return true;
    }

    this.toaster.pop({
      type: 'error',
      title: '请填写必填项',
      timeout: 3 * 1000
    });
    return false;
  }

}



// WEBPACK FOOTER //
// ./client/app/firmwares/edit/edit.controller.js